import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { IconButton, TextField } from "@mui/material";

import { CloseIcon } from "@/modules/Core/Icons/Close";
import { CloseSVG } from "./CloseSVG";

export default function InfoModal({ open, setOpen }) {
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Modal
      open={open}
      // onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={(theme) => ({
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "640px",
          bgcolor: "background.paper",
          boxShadow: 24,
          padding: "24px",
          borderRadius: "32px",
          [theme.breakpoints.down("sm")]: {
            width: "auto",
            padding: "16px",
            borderRadius: "16px",
            transform: "none",
            top: "auto",
            left: "0",
            right: "0",
            bottom: "0",
            borderEndStartRadius: "0",
            borderEndEndRadius: "0",
          },
        })}
      >
        <IconButton
          aria-label="delete"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            top: "24px",
            right: "24px",
            padding: "0",
            [theme.breakpoints.down("sm")]: {
              top: "28px",
              right: "16px",
            },
          })}
        >
          <CloseSVG />
        </IconButton>
        <Typography
          sx={(theme) => ({
            color: "#1C1C1E",
            fontSize: "24px",
            fontWeight: "600",
            lineHeight: "31px",
            marginBottom: "49px",
            [theme.breakpoints.down("sm")]: {
              marginRight: "56px",
              fontSize: "20px",
              fontWeight: "600",
              lineHeight: "26px",
              marginBottom: "30px",
            },
          })}
        >
          Справка с другого банка о доходах
        </Typography>
        <Typography
          sx={(theme) => ({
            color: "#676971",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "22px",
            marginBottom: "24px",
          })}
        >
          Справка должна быть на дату подачи заявки, за последние 12 месяцев с
          помесячной разбивкой, либо за период приложенной налоговой декларации.
        </Typography>
        <Typography
          sx={(theme) => ({
            color: "#676971",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "22px",
            marginBottom: "24px",
          })}
        >
          Несколько справок необходимо загрузить отдельно. Справка должна
          содержать ФИО подписанта, подпись и печать Банка.
        </Typography>

        <Typography
          sx={(theme) => ({
            color: "#676971",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "22px",
          })}
        >
          Справку необходимо отсканировать в хорошем качестве в формате pdf.
          Принимается также электронная справка из приложения kaspi (справка о
          доступном остатке и выписка за 12 месяцев с Kaspi GOLD) или Jusan с
          обязательным наличием QR кода.
        </Typography>
        <Button
          sx={(theme) => ({
            padding: "13px 24px",
            backgroundColor: "#27AE60",
            color: "#FFF",
            fontSize: "16px",
            fontWeight: "500",
            lineHeight: "24px",
            marginTop: "62px",
            float: "right",
            borderRadius: "10px",
            ":hover": {
              background: "#27AE60",
              color: "#FFF",
            },
            [theme.breakpoints.down("sm")]: {
              //   marginTop: '',
              width: "100%",
            },
          })}
          onClick={handleClose}
        >
          Понятно
        </Button>
      </Box>
    </Modal>
  );
}
